import RAPIER from '@dimforge/rapier3d-compat';

export type RapierNS = typeof RAPIER;

/** Collision callback: handles are Rapier collider handles. */
export type CollisionCb = (h1: number, h2: number, started: boolean) => void;

/**
 * Thin wrapper around a Rapier (WASM) world (§10). The compat build inlines the
 * WASM, so no bundler config is required. The game uses a capped fixed step.
 */
export class Physics {
  RAPIER!: RapierNS;
  world!: RAPIER.World;
  private eventQueue!: RAPIER.EventQueue;
  private gravityY = -30;

  /** Default down-slope gravity; tuned a bit stronger than Earth for snappy feel. */
  async init(gravityY = -30): Promise<void> {
    await RAPIER.init();
    this.RAPIER = RAPIER;
    this.gravityY = gravityY;
    this.world = new RAPIER.World({ x: 0, y: gravityY, z: 0 });
    this.world.timestep = 1 / 60;
    this.eventQueue = new RAPIER.EventQueue(true);
  }

  /** Drop the whole world (all bodies/colliders) and start fresh — used when
   * swapping levels. */
  reset(): void {
    this.world.free();
    this.world = new this.RAPIER.World({ x: 0, y: this.gravityY, z: 0 });
    this.world.timestep = 1 / 60;
    this.eventQueue = new this.RAPIER.EventQueue(true);
  }

  step(): void {
    this.world.step(this.eventQueue);
  }

  drainCollisions(cb: CollisionCb): void {
    this.eventQueue.drainCollisionEvents(cb);
  }
}
